import { fetch, Method } from 'core/api/fetch';

const ReportRoutes = {
    getAppReports: (params) => `/api/v1.1.1/experiencer/report/app?${params}`,
};

export const ReportService = {
    getAppReports: async (options) => {
        try {
            const params = new URLSearchParams();

            if (options?.filters) {
                const { startDate, endDate, timezone, contractId, experienceIds, experiencerIds, hostIds, paymentStatus, currency, originIds, paymentMethods } = options.filters;
                if (startDate) {
                    params.append('startDate', startDate.toISO?.() ?? startDate);
                }
                if (endDate) {
                    params.append('endDate', endDate.toISO?.() ?? endDate);
                }
                if (timezone) {
                    params.append('timezone', String(timezone));
                }
                if (Array.isArray(originIds) && originIds.length > 0) {
                    originIds.forEach(({ id }) => params.append('originIds', id));
                }
                if (Array.isArray(paymentMethods) && paymentMethods.length > 0) {
                    paymentMethods.forEach(({ id }) => params.append('paymentMethod', id));
                }
                if (contractId) {
                    params.append('contractId', contractId);
                }
                if (Array.isArray(experienceIds) && experienceIds.length > 0) {
                    experienceIds.forEach((id) => params.append('experience', id));
                }
                if (Array.isArray(experiencerIds) && experiencerIds.length > 0) {
                    experiencerIds.forEach((id) => params.append('experiencer', id));
                }
                if (Array.isArray(paymentStatus) && paymentStatus.length > 0) {
                    paymentStatus.forEach(({ id }) => params.append('status', id));
                }
                if (Array.isArray(hostIds) && hostIds.length > 0) {
                    hostIds.forEach((id) => params.append('host', id));
                }
                if (currency) {
                    params.append('currency', currency);
                }
            }

            const { data } = await fetch(ReportRoutes.getAppReports(params.toString()), {
                method: Method.GET,
                authenticated: true,
            });

            return !data ? {} : data;
        } catch (err) {
            throw new Error(err);
        }
    },
};
